var selectValue = {

	/**
	 * Zet selects op de option gelijk aan de value attribute
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function(target) {

		if (target instanceof $) {
			target = target[0];
		}

		if (typeof target !== 'undefined') {

			selectValue.initSetValue(target);
			selectValue.initSetValueIfSingle(target);

		}

	},
	/**
	 * Zet selects op de option gelijk aan de data-value attribute
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	initSetValue: function(target) {

		target.querySelectorAll('select[data-value]').forEach(function(select) {
			select.value = select.getAttribute('data-value');
			select.dispatchEvent(new Event('change'));
		});

	},

	/**
	 * Selecteer de enige selecteerbare waarde in select (één keuze is géén keuze)
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	initSetValueIfSingle: function(target) {

		target.querySelectorAll('select[data-select-if-single]:not([readonly])').forEach(function(select) {
			let options = select.querySelectorAll('option:not([disabled])');
			let optionElements = Array.from(options).filter(option => option.value !== '');

			if (optionElements.length === 1) {
				select.value = optionElements[0].value;
				select.dispatchEvent(new Event('change'));
			}
		});

	}

};

export default selectValue;
